export default {
  setAccounts(state, payload) {
    state.accounts = payload.accounts;
  },
  setProcedures(state, payload) {
    state.procedures = payload.procedures;
  },
  setFilterOptions(state, payload) {
    state.filterOptions = payload.procedures;
  },
  setFilters(state, payload) {
    state.filters[payload.filter] = payload.filterOptions;
  },
  saveToken(state, payload) {
    state.user.name = payload.name;
    state.user.email = payload.email;
    state.user.token = payload.token;
  },
  resetFilters(state, payload) {
    state.filters[payload.filter] = {
      country: null,
      state: null,
      city: null,
      company: null,
      startDate: null,
      endDate: null,
    };
  },
};
